import type { MemberPaymentsSearchFilters } from '@library/types/memberPayments';
import type { PaymentsAPIResponse } from '@library/types/payments';

export const colXsWidth = 'basis-[12.5%]';
export const colSmWidth = 'basis-2/12';
export const colMdWidth = 'basis-[18.75%]';
export const colLgWidth = 'basis-4/12';

export const DEFAULT_MEMBER_PAYMENTS: PaymentsAPIResponse = {
  deposits: [],
  withdrawals: [],
  user: {
    email: '',
    first_name: '',
    id: 0,
    last_name: '',
    phone_number: '',
    uuid: ''
  },
  paginationInfo: {
    current_page: 1,
    total_pages: 1
  }
};

export const DEFAULT_MEMBER_PAYMENTS_FILTERS: MemberPaymentsSearchFilters = {
  dateRange: {
    fromDate: undefined,
    toDate: undefined
  },
  depositStatus: undefined,
  depositMethodType: undefined
};

export const LOCATION_NOT_FOUND = {
  latitude: 'Latitude Not Available',
  longitude: 'Longitude Not Available',
  stateAbbreviation: 'Location Not Available'
};

// TODO: update to lower amount once new sort param is added to payment endpoint for infinite scroll
export const FETCH_MEMBER_PAYMENTS_PAGE_COUNT = 10000;
